import './index.less'


// WEBPACK FOOTER //
// ./ecology9/wea-dialog/style/index.js